import _ from "lodash";
import React from "react";
import classNames from "classnames";

// Design system
import { Modal } from "@toddle-edu/ds-web";

// Utils
import { AI_ANALYSIS_SCALE_MAPPING } from "@toddle-edu/common-utils";
import { getStyleStrippedText } from "Utils";

// Third-party
import hexToRgba from "hex-to-rgba";

// Scss
import classes from "./AIAnalysisCriteriaModal.scss";

const styles = {
  modalHeaderStyle: {
    padding: "20px 24px",
  },
  modalBodyStyle: {
    padding: "0 24px 24px 24px",
  },
};

const AIAnalysisCriteriaModal = props => {
  const { onClose, t, analysisCriteria } = props;

  const labelClass = classNames("text-body-2", classes.labelContainer);
  const descriptionClass = classNames(
    "text-body-2",
    classes.descriptionContainer
  );

  const labelBackgroundColour = colorCode => {
    const { color = "" } =
      _.find(AI_ANALYSIS_SCALE_MAPPING, { id: colorCode }) || {};
    return hexToRgba(color, 0.2);
  };

  return (
    <Modal
      dsVersion="2.0"
      onClose={onClose}
      width="fit-content"
      height="fit-content"
    >
      <Modal.Header
        isClosable={true}
        hasSeparator={false}
        title={t("ai:ai_analysis_scale")}
        style={styles.modalHeaderStyle}
      />

      <Modal.Body style={styles.modalBodyStyle}>
        <div className={classes.criteriaContainer}>
          {_.map(analysisCriteria, criteria => (
            <div key={criteria?.id} className={classes.criteriaRow}>
              <div
                className={labelClass}
                style={{
                  backgroundColor: labelBackgroundColour(
                    criteria?.metadata?.colorCode
                  ),
                }}
                dangerouslySetInnerHTML={{
                  __html: getStyleStrippedText({
                    text: criteria?.label,
                    type: "SANITIZE_DANGER_HTML_PARAGRAPH",
                  }),
                }}
              />

              <div
                className={descriptionClass}
                dangerouslySetInnerHTML={{
                  __html: getStyleStrippedText({
                    text: criteria?.description,
                    type: "SANITIZE_DANGER_HTML_PARAGRAPH",
                  }),
                }}
              />
            </div>
          ))}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AIAnalysisCriteriaModal;
